import canUseAllTimeslot from "@/components/helpers/meeting/can-use-all-timeslot";
import { Box, Flex } from "@/components/layout/flexbox";
import ToggleField from "@/components/pieces/form/ToggleField";
import Clickable from "@/components/pieces/interaction/Clickable";
import { MiniUserType } from "@/graphql";

interface AllTimeslotToggleProps {
  usedAllTimeslot?: boolean;
  onToggleUsedAllTimeslot?: () => void;
  coach?: Pick<MiniUserType, "id" | "firstName" | "lastName"> | null;
}

export default function AllTimeslotToggle({
  usedAllTimeslot = false,
  onToggleUsedAllTimeslot = () => {},
  coach = null,
}: AllTimeslotToggleProps) {
  if (!canUseAllTimeslot(coach)) {
    return null;
  }

  return (
    <Box
      css={{
        width: "fit-content",
      }}
    >
      <Clickable onClick={onToggleUsedAllTimeslot}>
        <Flex alignItems="center" mb={2}>
          <ToggleField
            checked={usedAllTimeslot}
            onChange={onToggleUsedAllTimeslot}
            size={10}
          />
          <Box fontSize={14} ml={2}>
            Show All Times
          </Box>
        </Flex>
      </Clickable>
    </Box>
  );
}
